import { getDateTime } from "../../services/CheckMeProBlePackages";
export function parseEcgItem(data) {
    var returnString = "";
    var ECGs = new Array();
    var block = 0;
    for (var i = 0; i < data.length; i++) {
        var item = {};
        item.date = getDateTime(data, i);
        item.measuringMode = data[i + 7];
        item.imgResult = data[i + 8];
        //yyyymmddhhmmss
        i = i + 9;
        ECGs.push(item);
        switch (item.imgResult) {
            case 0:
                item.imgResultDescr = "happy";
                break;
            case 1:
                item.imgResultDescr = "sad";
                break;
        }
        switch (item.measuringMode) {
            case 1:
                item.measuringModeDescr = "hand-hand";
                break;
            case 2:
                item.measuringModeDescr = "hand-chest";
                break;
            case 3:
                item.measuringModeDescr = "1-lead";
                break;
            case 4:
                item.measuringModeDescr = "2-lead";
                break;
        }
    }
    return ECGs;
}
